import React from 'react';
import { Button } from '../ui/button';
import { FileText, SpinnerGap, User, IdentificationCard, Globe } from '@phosphor-icons/react';
import { TemplateSelector, FormField, DateField, HistoryList, HistoryPanel } from './FormFields';

export const ContractTab = ({
  contractTemplates, selectedContractTemplateId, setSelectedContractTemplateId,
  contractForm, setContractForm, isGenerating, isAdmin,
  contracts, loadingContracts,
  onGenerate, onDownload, onDelete
}) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <div className="lg:col-span-2">
      <div className="border border-[#262626] bg-[#141414]">
        <div className="p-4 border-b border-[#262626]">
          <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#A3A3A3]">Данные клиента</h2>
        </div>
        <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <TemplateSelector templates={contractTemplates} selectedId={selectedContractTemplateId}
              onSelect={setSelectedContractTemplateId} testId="contract-template-select" isAdmin={isAdmin} />
          </div>
          <FormField icon={User} label="ФИО клиента" value={contractForm.fullName}
            onChange={(v) => setContractForm(p => ({...p, fullName: v}))} placeholder="IVANOV IVAN" testId="client-name-input" />
          <FormField icon={IdentificationCard} label="Паспорт / ID" value={contractForm.passportId}
            onChange={(v) => setContractForm(p => ({...p, passportId: v}))} placeholder="AA1234567" testId="passport-input" />
          <FormField icon={Globe} label="Страна" value={contractForm.address}
            onChange={(v) => setContractForm(p => ({...p, address: v}))} placeholder="AZERBAIJAN" testId="address-input" />
          <DateField label="Дата документа" date={contractForm.documentDate}
            onDateChange={(d) => setContractForm(p => ({...p, documentDate: d}))} testId="contract-date-picker" />
        </div>
        <div className="p-4 border-t border-[#262626]">
          <Button onClick={onGenerate} disabled={isGenerating || !selectedContractTemplateId}
            className="w-full h-12 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A0A0A] font-semibold rounded-none disabled:opacity-50"
            data-testid="generate-contract-btn">
            {isGenerating ? <><SpinnerGap size={20} className="animate-spin mr-2" />Генерация...</>
              : <><FileText size={20} className="mr-2" weight="bold" />Создать контракт</>}
          </Button>
        </div>
      </div>
    </div>
    <HistoryPanel title="История" count={contracts.length}>
      <HistoryList items={contracts} loading={loadingContracts}
        onDownload={onDownload} onDelete={onDelete} testPrefix="contract-item" />
    </HistoryPanel>
  </div>
);
